module.exports = __webpack_public_path__ + "d7a9b6e3c497259e8748a42c0201c315.pdf";